// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
* NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).  https://openapi-generator.tech  Do not edit the class manually.
*/
export var PrescriberPhoneContactInformationType;
(function (PrescriberPhoneContactInformationType) {
    PrescriberPhoneContactInformationType[PrescriberPhoneContactInformationType["UNKNOWN"] = 1] = "UNKNOWN";
    PrescriberPhoneContactInformationType[PrescriberPhoneContactInformationType["PHONE"] = 2] = "PHONE";
    PrescriberPhoneContactInformationType[PrescriberPhoneContactInformationType["MOBILE"] = 3] = "MOBILE";
})(PrescriberPhoneContactInformationType || (PrescriberPhoneContactInformationType = {}));
//# sourceMappingURL=prescriberPhoneContactInformationType.js.map